import type { NextPage } from "next";
import { LayoutChat } from "@acme/feature";

const Home: NextPage = () => {
  return <LayoutChat />
};

export default Home;

